import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VozIaService } from 'src/app/core/services/voz-ia.service';
import { VozIA, GenerateVoiceIARequest } from 'src/app/models/voz-ia';
import { AuthService } from 'src/app/core/services/auth.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { User } from 'src/app/models';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-voz-ia',
  templateUrl: './voz-ia.component.html',
  styleUrls: ['./voz-ia.component.css']
})
export class VozIaComponent implements OnInit {

  form!: FormGroup;
  voces: VozIA[] = [];
  hasAudio = false;
  loading = false;
  isPlaying = false;
  currentTime = 0;
  duration = 0;

  audioUrl: string | null = null;
  audioBase64: string | null = null;

  @ViewChild('audioRef') audioRef!: ElementRef<HTMLAudioElement>;

  constructor(private fb: FormBuilder, private vozIaService: VozIaService, private authService: AuthService, private storageService: StorageService) { }

  ngOnInit(): void {
    this.buildForm();
    this.getVocesIA();
  }

  private buildForm(): void {
    this.form = this.fb.group({
      text: ['', [Validators.required, Validators.minLength(5)]],
      voiceId: ['', Validators.required]
    });
  }

  private getVocesIA(): void {
    this.vozIaService.listarVocesIA().subscribe({
      next: (data) => this.voces = data,
      error: (err) => console.error('Error listando voces IA', err)
    });
  }

  generarVersion(): void {
    if (this.form.invalid) return;
  
    this.loading = true;
  
    Swal.fire({
      title: 'Generando audio',
      text: 'Por favor espera...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => Swal.showLoading()
    });
  
    const storedUser = this.storageService.decryptAndGetObject('user');
  
    const userEmail = storedUser?.email || 'user@pulzo.com';
  
    const selectedVoice = this.voces.find(
      v => v.voice_id === this.form.value.voiceId
    );
  
    const voiceName = selectedVoice?.name || 'IA';
  
    console.log('Usuario email:', userEmail);
    console.log('Voz seleccionada:', voiceName);
  
    const payload: GenerateVoiceIARequest = {
      text: this.form.value.text,
      voice_id: this.form.value.voiceId,
      user_name: userEmail,
      voice_name: voiceName
    };
  
    this.vozIaService.GenerateVoiceIA(payload).subscribe({
      next: (data) => {
        if (data.audio_base64) {
          this.audioBase64 = data.audio_base64;
          this.audioUrl = this.base64ToAudioUrl(data.audio_base64);
          this.hasAudio = true;
        }
  
        this.loading = false;
        Swal.close();
      },
      error: (err) => {
        console.error('Error generando audio IA', err);
        this.loading = false;
  
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el audio. Intenta nuevamente.'
        });
      }
    });
  }  
  
  

  regenerarAudio(): void {
    this.hasAudio = false;
    this.audioUrl = null;
    this.audioBase64 = null;
  }

  downloadAudio(): void {
    if (!this.audioBase64) return;

    const byteCharacters = atob(this.audioBase64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'audio/mpeg' });

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'voz-ia.mp3';
    a.click();

    URL.revokeObjectURL(url);
  }


  private base64ToAudioUrl(base64: string): string {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'audio/mpeg' });

    return URL.createObjectURL(blob);
  }

  get audio(): HTMLAudioElement {
    return this.audioRef?.nativeElement;
  }

  onAudioLoaded(): void {
    if (!this.audio) return;
    this.duration = this.audio.duration;
  }

  togglePlay(): void {
    if (!this.audio) return;

    if (this.audio.paused) {
      this.audio.play();
      this.isPlaying = true;
    } else {
      this.audio.pause();
      this.isPlaying = false;
    }
  }

  onTimeUpdate(): void {
    if (!this.audio) return;
    this.currentTime = this.audio.currentTime;
  }

  seek(event: Event): void {
    if (!this.audio) return;
    this.audio.currentTime = +(event.target as HTMLInputElement).value;
  }

  skip(seconds: number): void {
    if (!this.audio) return;
    this.audio.currentTime = Math.max(
      0,
      Math.min(this.audio.currentTime + seconds, this.duration)
    );
  }

  formatTime(time: number): string {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }


}
